export default "__VITE_ASSET__IMt$O$Vm__"